<template>
  <v-btn
    :class="$vuetify.breakpoint.mdAndUp ? 'btn-desktop' : 'btn-mobile'"
    color="primary"
    :disabled="desabilitarBtn"
    :data-cy="'btn_prosseguir_passo_' + index"
    @click="setProximo"
  >
    Prosseguir
  </v-btn>
</template>

<script>
export default {
  name: 'BtnProsseguir',

  props: {
    index: {
      type: Number,
      required: true,
    },
    desabilitarBtn: {
      type: Boolean,
    },
    naoProseguir: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    setProximo() {
      if (!this.naoProseguir) {
        this.$emit('irParaProximo', this.index + 1);
      } else {
        this.$emit('naoIrParaProximo', true);
      }
    },
  },
};
</script>
